/* tslint:disable */
/* eslint-disable */
/* @relayHash 1a2966857c98868b173962d2f984d971 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type PdpRespLayoutRefetchQueryVariables = {
    isClient: boolean;
    itemId: string;
    itemIds: Array<string | null>;
    userId?: string | null;
    userIds?: Array<string | null> | null;
    fetchUser: boolean;
    followSearchPages?: Array<string | null> | null;
    fetchFollowSearch: boolean;
    isTrade: boolean;
    isMultiSku: boolean;
    fetchPdp: boolean;
    forcedCurrency?: Currency | null;
    userZipCode?: string | null;
    userCountryCode?: string | null;
    fetchRegionalInfo?: boolean | null;
    localRecentHistoryItemIds?: Array<string | null> | null;
    fetchUserRecentHistoryItem?: boolean | null;
    isStoryTellingModuleVariant: boolean;
    isInteractivePdpChat?: boolean | null;
};
export type PdpRespLayoutRefetchQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"PdpRespLayout_viewer">;
    };
};
export type PdpRespLayoutRefetchQuery = {
    readonly response: PdpRespLayoutRefetchQueryResponse;
    readonly variables: PdpRespLayoutRefetchQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "isClient",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "itemId",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "itemIds",
    "type": "[String]!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "userIds",
    "type": "[String]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "fetchUser",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "followSearchPages",
    "type": "[String]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "fetchFollowSearch",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "isTrade",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "isMultiSku",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "fetchPdp",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "forcedCurrency",
    "type": "Currency",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "userZipCode",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "userCountryCode",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "fetchRegionalInfo",
    "type": "Boolean",
    "defaultValue": false
  },
  {
    "kind": "LocalArgument",
    "name": "localRecentHistoryItemIds",
    "type": "[String]",
    "defaultValue": ([]/*: any*/)
  },
  {
    "kind": "LocalArgument",
    "name": "fetchUserRecentHistoryItem",
    "type": "Boolean",
    "defaultValue": false
  },
  {
    "kind": "LocalArgument",
    "name": "isStoryTellingModuleVariant",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "isInteractivePdpChat",
    "type": "Boolean",
    "defaultValue": true
  }
],
v1 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userId"
},
v2 = {
  "kind": "Variable",
  "name": "itemId",
  "variableName": "itemId"
},
v3 = [
  (v1/*: any*/),
  (v2/*: any*/)
],
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currency",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount",
  "args": null,
  "storageKey": null
},
v7 = [
  (v5/*: any*/),
  (v6/*: any*/)
],
v8 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "convertedAmountList",
  "storageKey": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "plural": true,
  "selections": (v7/*: any*/)
},
v9 = [
  (v8/*: any*/)
],
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceMethodType",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "code",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "regionName",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "buyerServiceMethodDisplay",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "displayCityStateCountry",
  "args": null,
  "storageKey": null
},
v16 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 8
  },
  (v2/*: any*/),
  {
    "kind": "Literal",
    "name": "seller",
    "value": "EXCLUDE"
  }
],
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "categoryPath",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "browseUrl",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "categoryCode",
  "args": null,
  "storageKey": null
},
v21 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "ecommerceTrackingParams",
  "args": null,
  "storageKey": null
},
v23 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isFurniture",
  "args": null,
  "storageKey": null
},
v24 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "localizedPdpUrl",
  "args": null,
  "storageKey": null
},
v25 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "classification",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemClassification",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "creationDate",
      "args": null,
      "storageKey": null
    }
  ]
},
v26 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "displayName",
  "args": null,
  "storageKey": null
},
v27 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "creators",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemCreator",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "attribution",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "creator",
      "storageKey": null,
      "args": null,
      "concreteType": "Creator",
      "plural": false,
      "selections": [
        (v26/*: any*/),
        (v10/*: any*/)
      ]
    },
    (v10/*: any*/)
  ]
},
v28 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isArt",
  "args": null,
  "storageKey": null
},
v29 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "path",
  "args": null,
  "storageKey": null
},
v30 = [
  (v29/*: any*/),
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "isLinkable",
    "args": null,
    "storageKey": null
  }
],
v31 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "linkData",
  "storageKey": null,
  "args": null,
  "concreteType": "LinkData",
  "plural": false,
  "selections": (v30/*: any*/)
},
v32 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "vertical",
  "args": null,
  "storageKey": null
},
v33 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isComplimentary",
  "args": null,
  "storageKey": null
},
v34 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "totalAmount",
  "storageKey": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "plural": false,
  "selections": [
    (v6/*: any*/)
  ]
},
v35 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "shipmentQuotes",
  "storageKey": null,
  "args": null,
  "concreteType": "ShipmentQuote",
  "plural": true,
  "selections": [
    (v33/*: any*/),
    (v34/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "serviceMethod",
      "storageKey": null,
      "args": null,
      "concreteType": "ShipmentServiceMethod",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "region",
          "storageKey": null,
          "args": null,
          "concreteType": "Region",
          "plural": false,
          "selections": [
            (v13/*: any*/),
            (v10/*: any*/)
          ]
        },
        (v10/*: any*/)
      ]
    },
    (v10/*: any*/)
  ]
},
v36 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isStorefrontOnly",
  "args": null,
  "storageKey": null
},
v37 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isMultiSku",
  "args": null,
  "storageKey": null
},
v38 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "imageUrl",
  "args": null,
  "storageKey": null
},
v39 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "variableAttributes",
  "storageKey": null,
  "args": null,
  "concreteType": "VariableAttribute",
  "plural": true,
  "selections": [
    (v17/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "variableAttributeData",
      "storageKey": null,
      "args": null,
      "concreteType": "VariableAttributeSortType",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "swatchSort",
          "storageKey": null,
          "args": null,
          "concreteType": "SwatchSort",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "swatch",
              "storageKey": null,
              "args": null,
              "concreteType": "Swatch",
              "plural": false,
              "selections": [
                (v17/*: any*/),
                (v26/*: any*/),
                (v38/*: any*/),
                (v10/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    (v10/*: any*/)
  ]
},
v40 = {
  "kind": "Variable",
  "name": "isTrade",
  "variableName": "isTrade"
},
v41 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "convertedAmountList",
  "storageKey": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    (v5/*: any*/)
  ]
},
v42 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantityDisplay",
  "args": null,
  "storageKey": null
},
v43 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "percentageOff",
  "args": null,
  "storageKey": null
},
v44 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "textType",
  "args": null,
  "storageKey": null
},
v45 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amountType",
  "args": null,
  "storageKey": null
},
v46 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showPriceLabel",
  "args": null,
  "storageKey": null
},
v47 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showPriceVariability",
  "args": null,
  "storageKey": null
},
v48 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "displayPrice",
  "storageKey": null,
  "args": [
    (v40/*: any*/),
    {
      "kind": "Literal",
      "name": "page",
      "value": "searchAndBrowse"
    }
  ],
  "concreteType": "ItemDisplayPriceType",
  "plural": true,
  "selections": [
    (v41/*: any*/),
    (v42/*: any*/),
    (v43/*: any*/),
    (v44/*: any*/),
    (v45/*: any*/),
    (v46/*: any*/),
    (v47/*: any*/)
  ]
},
v49 = [
  {
    "kind": "Literal",
    "name": "formatType",
    "value": "MOBILE"
  }
],
v50 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "key",
  "args": null,
  "storageKey": null
},
v51 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "text",
  "args": null,
  "storageKey": null
},
v52 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "quickViewDisplay",
  "storageKey": null,
  "args": null,
  "concreteType": "QuickViewDisplayType",
  "plural": false,
  "selections": [
    (v21/*: any*/),
    {
      "kind": "ScalarField",
      "alias": "mobileTitle",
      "name": "title",
      "args": (v49/*: any*/),
      "storageKey": "title(formatType:\"MOBILE\")"
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "paragraphs",
      "storageKey": null,
      "args": null,
      "concreteType": "QuickViewParagraph",
      "plural": true,
      "selections": [
        (v50/*: any*/),
        (v51/*: any*/),
        {
          "kind": "ScalarField",
          "alias": "mobileText",
          "name": "text",
          "args": (v49/*: any*/),
          "storageKey": "text(formatType:\"MOBILE\")"
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "paragraphAttributeNames",
      "storageKey": null,
      "args": null,
      "concreteType": "QuickViewCategorySegments",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "period",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "origin",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "style",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "periodPrefix",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "creators",
      "storageKey": null,
      "args": null,
      "concreteType": "QuickViewCreator",
      "plural": true,
      "selections": [
        (v26/*: any*/),
        (v31/*: any*/)
      ]
    }
  ]
},
v53 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "value",
  "args": null,
  "storageKey": null
},
v54 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "unit",
    "args": null,
    "storageKey": null
  },
  (v53/*: any*/)
],
v55 = [
  (v53/*: any*/)
],
v56 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "measurement",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemMeasurement",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "display",
      "storageKey": "display(addLabel:true,fields:[\"height\",\"width\",\"depth\",\"diameter\",\"length\"],separator:\" \")",
      "args": [
        {
          "kind": "Literal",
          "name": "addLabel",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "fields",
          "value": [
            "height",
            "width",
            "depth",
            "diameter",
            "length"
          ]
        },
        {
          "kind": "Literal",
          "name": "separator",
          "value": " "
        }
      ],
      "concreteType": "ItemDisplayMeasurementType",
      "plural": true,
      "selections": (v54/*: any*/)
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "size",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemSize",
      "plural": false,
      "selections": (v55/*: any*/)
    }
  ]
},
v57 = [
  {
    "kind": "Literal",
    "name": "limit",
    "value": 1
  }
],
v58 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "placeholder",
  "args": null,
  "storageKey": null
},
v59 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "masterOrZoomPath",
  "args": null,
  "storageKey": null
},
v60 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "webPath",
  "args": null,
  "storageKey": null
},
v61 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "versions",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemPhotoVersion",
  "plural": true,
  "selections": [
    (v60/*: any*/)
  ]
},
v62 = {
  "kind": "LinkedField",
  "alias": "productPhotos",
  "name": "photos",
  "storageKey": "photos(limit:1)",
  "args": (v57/*: any*/),
  "concreteType": "ItemPhoto",
  "plural": true,
  "selections": [
    (v58/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "smallPath",
      "args": null,
      "storageKey": null
    },
    (v59/*: any*/),
    (v61/*: any*/),
    (v10/*: any*/)
  ]
},
v63 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v64 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v65 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasNextPage",
  "args": null,
  "storageKey": null
},
v66 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "endCursor",
  "args": null,
  "storageKey": null
},
v67 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "totalResults",
  "args": null,
  "storageKey": null
},
v68 = {
  "kind": "Variable",
  "name": "countryCode",
  "variableName": "userCountryCode"
},
v69 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 6
  },
  (v2/*: any*/),
  {
    "kind": "Literal",
    "name": "seller",
    "value": "INCLUDE"
  }
],
v70 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    (v66/*: any*/),
    (v65/*: any*/)
  ]
},
v71 = [
  {
    "kind": "Variable",
    "name": "itemIds",
    "variableName": "itemIds"
  }
],
v72 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v73 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "skuId",
  "args": null,
  "storageKey": null
},
v74 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantity",
  "args": null,
  "storageKey": null
},
v75 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasUnlimitedQuantity",
  "args": null,
  "storageKey": null
},
v76 = [
  {
    "kind": "Literal",
    "name": "pageType",
    "value": "PDP"
  }
],
v77 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "displayPrice",
  "storageKey": null,
  "args": [
    (v1/*: any*/),
    (v40/*: any*/)
  ],
  "concreteType": "ItemDisplayPriceType",
  "plural": true,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "originalConvertedAmountList",
      "storageKey": null,
      "args": null,
      "concreteType": "ConvertedAmountList",
      "plural": true,
      "selections": (v7/*: any*/)
    },
    (v8/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "privateOfferConvertedAmountList",
      "storageKey": null,
      "args": null,
      "concreteType": "ConvertedAmountList",
      "plural": true,
      "selections": (v7/*: any*/)
    },
    (v42/*: any*/),
    (v43/*: any*/),
    (v44/*: any*/),
    (v45/*: any*/),
    (v46/*: any*/),
    (v47/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "offerExpirationDate",
      "args": null,
      "storageKey": null
    }
  ]
},
v78 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "shipmentDeliveryEstimations",
  "storageKey": null,
  "args": null,
  "concreteType": "ShipmentDeliveryEstimationsType",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "shipmentQuoteId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "maxDaysToDeliver",
      "args": null,
      "storageKey": null
    }
  ]
},
v79 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "firstPhotoWebPath",
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": "small"
    }
  ],
  "storageKey": "firstPhotoWebPath(size:\"small\")"
},
v80 = [
  {
    "kind": "Literal",
    "name": "size",
    "value": "thumb"
  }
],
v81 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "caption",
  "args": null,
  "storageKey": null
},
v82 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "mediaType",
  "args": null,
  "storageKey": null
},
v83 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url",
  "args": null,
  "storageKey": null
},
v84 = [
  (v17/*: any*/),
  (v10/*: any*/)
],
v85 = [
  {
    "kind": "Literal",
    "name": "fullCountryName",
    "value": true
  }
],
v86 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "largePath",
  "args": null,
  "storageKey": null
},
v87 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "sortOrder",
  "args": null,
  "storageKey": null
},
v88 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "contemporaryTrackingString",
  "args": null,
  "storageKey": null
},
v89 = [
  (v1/*: any*/)
],
v90 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "urlLabel",
  "args": null,
  "storageKey": null
},
v91 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v92 = [
  (v91/*: any*/)
],
v93 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "htmlCopy",
    "args": null,
    "storageKey": null
  }
],
v94 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "pdpURL",
  "args": null,
  "storageKey": null
},
v95 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v96 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "detailKey",
  "args": null,
  "storageKey": null
},
v97 = [
  (v1/*: any*/),
  {
    "kind": "Literal",
    "name": "page",
    "value": "pdp"
  }
],
v98 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showHoldRequest",
  "args": null,
  "storageKey": null
},
v99 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showPurchase",
  "args": null,
  "storageKey": null
},
v100 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showMakeOffer",
  "args": null,
  "storageKey": null
},
v101 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showRequestPrice",
  "args": null,
  "storageKey": null
},
v102 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showRequestSourcing",
  "args": null,
  "storageKey": null
},
v103 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showFollowCategory",
  "args": null,
  "storageKey": null
},
v104 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showAcceptOffer",
  "args": null,
  "storageKey": null
},
v105 = [
  (v72/*: any*/)
],
v106 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "alt",
  "args": null,
  "storageKey": null
},
v107 = [
  (v72/*: any*/),
  (v10/*: any*/)
],
v108 = {
  "kind": "Literal",
  "name": "addLabel",
  "value": false
},
v109 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "creatorName",
  "args": null,
  "storageKey": null
},
v110 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "creatorBrowseUrl",
  "storageKey": null,
  "args": null,
  "concreteType": "LinkData",
  "plural": false,
  "selections": (v30/*: any*/)
},
v111 = [
  (v6/*: any*/),
  (v5/*: any*/),
  (v8/*: any*/)
],
v112 = [
  (v12/*: any*/),
  (v10/*: any*/)
],
v113 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "daysRelativeToExpiration",
  "args": [
    {
      "kind": "Literal",
      "name": "truncate",
      "value": false
    }
  ],
  "storageKey": "daysRelativeToExpiration(truncate:false)"
},
v114 = {
  "kind": "Literal",
  "name": "first",
  "value": 12
},
v115 = [
  {
    "kind": "Variable",
    "name": "excludeItemPks",
    "variableName": "localRecentHistoryItemIds"
  },
  (v114/*: any*/)
],
v116 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isCanceled",
  "args": null,
  "storageKey": null
},
v117 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "itemRead",
  "storageKey": null,
  "args": (v71/*: any*/),
  "concreteType": null,
  "plural": true,
  "selections": [
    (v63/*: any*/),
    {
      "kind": "InlineFragment",
      "type": "Item",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "seller",
          "storageKey": null,
          "args": null,
          "concreteType": "Seller",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "shippingAddress",
              "storageKey": null,
              "args": null,
              "concreteType": "Address",
              "plural": false,
              "selections": [
                (v15/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ]
},
v118 = {
  "kind": "ScalarField",
  "alias": "isPinterestShareEnabled",
  "name": "isEnabledByLocale",
  "args": [
    {
      "kind": "Literal",
      "name": "featureName",
      "value": "PINTEREST_SHARE"
    }
  ],
  "storageKey": "isEnabledByLocale(featureName:\"PINTEREST_SHARE\")"
},
v119 = {
  "kind": "ScalarField",
  "alias": "isFacebookShareEnabled",
  "name": "isEnabledByLocale",
  "args": [
    {
      "kind": "Literal",
      "name": "featureName",
      "value": "FACEBOOK_SHARE"
    }
  ],
  "storageKey": "isEnabledByLocale(featureName:\"FACEBOOK_SHARE\")"
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "PdpRespLayoutRefetchQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "PdpRespLayout_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "PdpRespLayoutRefetchQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": "isPopularSearchesEnabled",
            "name": "featureFlag",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "popularSearches"
              }
            ],
            "storageKey": "featureFlag(feature:\"popularSearches\")"
          },
          {
            "kind": "ScalarField",
            "alias": "pdpHolidayShippingFeatureFlag",
            "name": "featureFlag",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "pdpHolidayShipping"
              }
            ],
            "storageKey": "featureFlag(feature:\"pdpHolidayShipping\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isMultiRequestModalEnabled",
            "name": "featureFlag",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "multiRequestContactModal"
              }
            ],
            "storageKey": "featureFlag(feature:\"multiRequestContactModal\")"
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "relevantShipping",
            "storageKey": null,
            "args": (v3/*: any*/),
            "concreteType": "RelevantShippingInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "quoteRequestStatus",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "shipmentQuote",
                "storageKey": null,
                "args": null,
                "concreteType": "ShipmentQuote",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isCustom",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isNew",
                    "args": null,
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "buyerTotalAmount",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "FinancialAmount",
                    "plural": false,
                    "selections": (v9/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "serviceMethod",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ShipmentServiceMethod",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isWhiteGlove",
                        "args": null,
                        "storageKey": null
                      },
                      (v10/*: any*/),
                      (v11/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "region",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Region",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "apiType",
                            "args": null,
                            "storageKey": null
                          },
                          (v12/*: any*/),
                          (v13/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "regionType",
                            "args": null,
                            "storageKey": null
                          },
                          (v10/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "showQuoteAsPending",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "handlingTimeDisplay",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "displayShort",
                        "value": true
                      }
                    ],
                    "storageKey": "handlingTimeDisplay(displayShort:true)"
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "totalAmount",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "FinancialAmount",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v8/*: any*/)
                    ]
                  },
                  (v14/*: any*/),
                  (v10/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "shipment",
                "storageKey": null,
                "args": null,
                "concreteType": "Shipment",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "shippingAddress",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Address",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      (v10/*: any*/)
                    ]
                  },
                  (v10/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": "soldHoldPdpSourcingModal",
            "name": "featureFlag",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "soldHoldPdpSourcingModal"
              }
            ],
            "storageKey": "featureFlag(feature:\"soldHoldPdpSourcingModal\")"
          },
          {
            "kind": "LinkedField",
            "alias": "similarItems",
            "name": "moreLikeThisItem",
            "storageKey": null,
            "args": (v16/*: any*/),
            "concreteType": "moreLikeThisItemConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "moreLikeThisItemEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Item",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/),
                      (v27/*: any*/),
                      (v28/*: any*/),
                      (v31/*: any*/),
                      (v32/*: any*/),
                      (v35/*: any*/),
                      (v36/*: any*/),
                      (v37/*: any*/),
                      (v39/*: any*/),
                      (v48/*: any*/),
                      (v52/*: any*/),
                      (v56/*: any*/),
                      (v62/*: any*/),
                      (v10/*: any*/),
                      (v63/*: any*/)
                    ]
                  },
                  (v64/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "pageInfo",
                "storageKey": null,
                "args": null,
                "concreteType": "PageInfo",
                "plural": false,
                "selections": [
                  (v65/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "startCursor",
                    "args": null,
                    "storageKey": null
                  },
                  (v66/*: any*/)
                ]
              },
              (v67/*: any*/)
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": "similarItems",
            "name": "moreLikeThisItem",
            "args": (v16/*: any*/),
            "handle": "connection",
            "key": "PdpRespSimilarItemsFooter_similarItems",
            "filters": [
              "seller",
              "itemId"
            ]
          },
          {
            "kind": "ScalarField",
            "alias": "isSeoQuicklookEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "SEO_QUICKLOOK"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"SEO_QUICKLOOK\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isFavoritesEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "FAVORITES"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"FAVORITES\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isMessageCenterEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "MESSAGE_CENTER"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"MESSAGE_CENTER\")"
          },
          {
            "kind": "ScalarField",
            "alias": "disableEmailOnlyMc",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "DISABLE_EMAIL_ONLY_MC"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"DISABLE_EMAIL_ONLY_MC\")"
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "gdprDisplayInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "gdprDisplayInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isGdprApplicable",
                "args": [
                  (v68/*: any*/)
                ],
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "marketingOptInMessage",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": "sellerItems",
            "name": "moreLikeThisItem",
            "storageKey": null,
            "args": (v69/*: any*/),
            "concreteType": "moreLikeThisItemConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "moreLikeThisItemEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Item",
                    "plural": false,
                    "selections": [
                      (v22/*: any*/),
                      (v18/*: any*/),
                      (v20/*: any*/),
                      (v17/*: any*/),
                      (v19/*: any*/),
                      (v21/*: any*/),
                      (v23/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/),
                      (v27/*: any*/),
                      (v28/*: any*/),
                      (v31/*: any*/),
                      (v32/*: any*/),
                      (v35/*: any*/),
                      (v36/*: any*/),
                      (v37/*: any*/),
                      (v39/*: any*/),
                      (v48/*: any*/),
                      (v52/*: any*/),
                      (v56/*: any*/),
                      (v62/*: any*/),
                      (v10/*: any*/),
                      (v63/*: any*/)
                    ]
                  },
                  (v64/*: any*/)
                ]
              },
              (v70/*: any*/)
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": "sellerItems",
            "name": "moreLikeThisItem",
            "args": (v69/*: any*/),
            "handle": "connection",
            "key": "PdpRespSimilarItemTileCarousel_sellerItems",
            "filters": []
          },
          {
            "kind": "ScalarField",
            "alias": "isReviewsEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "ORDER_FEEDBACK"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"ORDER_FEEDBACK\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isItemInvoiceEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "INVOICE"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"INVOICE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "pdpChatFeatureFlag",
            "name": "featureFlag",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "pdpChat"
              }
            ],
            "storageKey": "featureFlag(feature:\"pdpChat\")"
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "itemRead",
            "storageKey": null,
            "args": (v71/*: any*/),
            "concreteType": null,
            "plural": true,
            "selections": [
              (v63/*: any*/),
              (v10/*: any*/),
              {
                "kind": "InlineFragment",
                "type": "Item",
                "selections": [
                  (v17/*: any*/),
                  (v37/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "defaultSkuId",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "saveSearchData",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SaveSearchDataType",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "page",
                        "args": null,
                        "storageKey": null
                      },
                      (v72/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "skus",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemSkuType",
                    "plural": true,
                    "selections": [
                      (v73/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "images",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ItemPhoto",
                        "plural": true,
                        "selections": [
                          (v10/*: any*/)
                        ]
                      },
                      (v10/*: any*/),
                      (v17/*: any*/),
                      (v74/*: any*/),
                      (v75/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "quantitySelectOptions",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SkuQuantityOption",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "label",
                            "args": null,
                            "storageKey": null
                          },
                          (v53/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "setSize",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": "skuLeadTime",
                        "name": "leadTime",
                        "args": (v76/*: any*/),
                        "storageKey": "leadTime(pageType:\"PDP\")"
                      },
                      {
                        "kind": "Condition",
                        "passingValue": true,
                        "condition": "isMultiSku",
                        "selections": [
                          (v77/*: any*/),
                          (v78/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v79/*: any*/),
                  (v21/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "itemType",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isSold",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": "image",
                    "name": "firstPhotoWebPath",
                    "args": (v80/*: any*/),
                    "storageKey": "firstPhotoWebPath(size:\"thumb\")"
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isListingNotListed",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isListingUnlisted",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "seller",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Seller",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isInternal",
                        "args": null,
                        "storageKey": null
                      },
                      (v10/*: any*/),
                      (v17/*: any*/),
                      (v4/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": "isRewardsTier2",
                        "name": "isAnchorListMember",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "listName",
                            "value": "SELLER_REWARDS_2"
                          }
                        ],
                        "storageKey": "isAnchorListMember(listName:\"SELLER_REWARDS_2\")"
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "liveStorefrontProfile",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "StorefrontProfile",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "aboutUsUnbranded",
                            "args": null,
                            "storageKey": null
                          },
                          (v10/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "galleryAlbum",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "MediaAlbum",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "mediaList",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "MediaElement",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "element",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": null,
                                    "plural": false,
                                    "selections": [
                                      (v63/*: any*/),
                                      (v10/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "type": "Photo",
                                        "selections": [
                                          (v29/*: any*/),
                                          (v81/*: any*/),
                                          (v82/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "type": "Video",
                                        "selections": [
                                          (v83/*: any*/),
                                          (v81/*: any*/),
                                          (v82/*: any*/)
                                        ]
                                      }
                                    ]
                                  },
                                  (v10/*: any*/)
                                ]
                              },
                              (v10/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": "headshots",
                            "name": "photos",
                            "storageKey": "photos(photoType:\"DEALER_STOREFRONT_HEADSHOT\")",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "photoType",
                                "value": "DEALER_STOREFRONT_HEADSHOT"
                              }
                            ],
                            "concreteType": "Photo",
                            "plural": true,
                            "selections": [
                              (v4/*: any*/),
                              (v29/*: any*/),
                              (v10/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "orderFeedbackPdp",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SellerOrderFeedbackPdpQueryConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "metadata",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "SellerOrderFeedbackPdpQueryMetadata",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "aggregatedFeedback",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "AggregatedOrderFeedbackType",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "overallExperience",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "AggregatedOrderFeedbackQuestionType",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "mean",
                                        "args": null,
                                        "storageKey": null
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          (v67/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "SellerOrderFeedbackPdpQueryEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "OrderFeedbackPdp",
                                "plural": false,
                                "selections": (v84/*: any*/)
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": "monthsSinceStartDate",
                        "name": "timeSinceStartDate",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "unit",
                            "value": "MONTH"
                          }
                        ],
                        "storageKey": "timeSinceStartDate(unit:\"MONTH\")"
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "sellerProfile",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SellerProfile",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "company",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "establishmentYear",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "shippingAddress",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Address",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": "displayFullCityStateCountry",
                            "name": "displayCityStateCountry",
                            "args": (v85/*: any*/),
                            "storageKey": "displayCityStateCountry(fullCountryName:true)"
                          },
                          (v10/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isDistinguished",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "sellerTiers",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SellerTiers",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isGoldTier",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isPlatinumTier",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "sellerTierDataNotFound",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "agreementStart",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "sellerOrderQuantity",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "analytics",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "MCAnalytics",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "metrics",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "MCAnalyticsMetrics",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "responseTime",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "MCMetricResponseTime",
                                "plural": false,
                                "selections": (v55/*: any*/)
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "tradeAssociations",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TradeAssociation",
                        "plural": true,
                        "selections": [
                          (v17/*: any*/),
                          (v26/*: any*/),
                          (v10/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isJewelrySeller",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "breadcrumbs",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemBreadcrumb",
                    "plural": true,
                    "selections": [
                      (v50/*: any*/),
                      (v29/*: any*/),
                      (v26/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "photos",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemPhoto",
                    "plural": true,
                    "selections": [
                      (v86/*: any*/),
                      (v10/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "sortedPhotos",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemPhoto",
                    "plural": true,
                    "selections": [
                      (v86/*: any*/),
                      (v87/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "imageSkuXrefs",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ImageSkuXref",
                        "plural": true,
                        "selections": [
                          (v73/*: any*/),
                          (v10/*: any*/)
                        ]
                      },
                      (v10/*: any*/)
                    ]
                  },
                  (v28/*: any*/),
                  (v32/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "creators",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemCreator",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "creator",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Creator",
                        "plural": false,
                        "selections": [
                          (v72/*: any*/),
                          (v26/*: any*/),
                          (v10/*: any*/)
                        ]
                      },
                      (v10/*: any*/)
                    ]
                  },
                  (v25/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isPrivateVisibilityType",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hasPrivateListing",
                    "args": null,
                    "storageKey": null
                  },
                  (v88/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "pricing",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemPricing",
                    "plural": false,
                    "selections": [
                      (v34/*: any*/)
                    ]
                  },
                  (v20/*: any*/),
                  (v19/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isDepositAvailable",
                    "args": (v89/*: any*/),
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isNewAndMadeToOrder",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "attributes",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemAttributes",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "leadTime",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "AttributeValue",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "option",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "AttributeOption",
                            "plural": false,
                            "selections": [
                              (v72/*: any*/),
                              (v90/*: any*/),
                              (v10/*: any*/)
                            ]
                          },
                          (v53/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "frameIncluded",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "AttributeValue",
                        "plural": true,
                        "selections": (v55/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "customizable",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "AttributeValue",
                        "plural": true,
                        "selections": [
                          (v51/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v35/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "customsMessaging",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "CustomsMessagingType",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "message",
                        "args": null,
                        "storageKey": null
                      },
                      (v12/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hasShipmentQuotes",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": "itemIsOnHold",
                    "name": "isOnHold",
                    "args": (v89/*: any*/),
                    "storageKey": null
                  },
                  (v78/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hasPreQuotedShipping",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "locationBrowseUrl",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "LinkData",
                    "plural": false,
                    "selections": (v30/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "address",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Address",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": "itemAddress",
                        "name": "displayCityStateCountry",
                        "args": (v85/*: any*/),
                        "storageKey": "displayCityStateCountry(fullCountryName:true)"
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isGalleryRoomAddress",
                        "args": null,
                        "storageKey": null
                      },
                      (v10/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "returnPolicy",
                    "storageKey": null,
                    "args": (v92/*: any*/),
                    "concreteType": "ReturnPolicy",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "accept",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "buyerCopy",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ReturnPolicyCopy",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "returnPolicySection",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "InlineCtaCopy",
                            "plural": false,
                            "selections": (v93/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "returnPolicySectionCtaCopy",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "InlineCtaCopy",
                            "plural": false,
                            "selections": (v93/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "customizableDetailReturnCopy",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "InlineCtaCopy",
                            "plural": false,
                            "selections": (v93/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "returnPolicySectionHeader",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "InlineCtaCopy",
                            "plural": false,
                            "selections": (v93/*: any*/)
                          }
                        ]
                      },
                      (v10/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isCustomizable",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "dibsReference",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isDeleted",
                    "args": null,
                    "storageKey": null
                  },
                  (v94/*: any*/),
                  (v18/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isComplete",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isListingListed",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "popularSearchesLink",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "LinkData",
                    "plural": false,
                    "selections": [
                      (v51/*: any*/),
                      (v29/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "activeHold",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Hold",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "displayTimeToExpire",
                        "args": null,
                        "storageKey": null
                      },
                      (v10/*: any*/)
                    ]
                  },
                  (v77/*: any*/),
                  (v95/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "englishDescription",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "leadTimeDisplay",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isJewelry",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "pdpDetailsDisplay",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PdpDetail",
                    "plural": true,
                    "selections": [
                      (v96/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "delimiter",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "detailDisplayName",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "detailValues",
                        "storageKey": null,
                        "args": null,
                        "concreteType": null,
                        "plural": true,
                        "selections": [
                          (v63/*: any*/),
                          (v96/*: any*/),
                          (v19/*: any*/),
                          (v26/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "displayDetails",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "linkOrder",
                            "args": null,
                            "storageKey": null
                          },
                          (v73/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "type": "PdpDetailVersionsValue",
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "price",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "plural": false,
                                "selections": (v9/*: any*/)
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isAvailable",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "isClient",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "pdpTrackingVpvParams",
                        "args": (v92/*: any*/),
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": "makeOfferVpvParams",
                        "name": "pdpTrackingVpvParams",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "excludedPurchaseStatuses",
                            "value": [
                              "RET",
                              "CUST"
                            ]
                          },
                          (v91/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "hasRequestedHoldForBuyer",
                        "args": (v89/*: any*/),
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "displayInfo",
                        "storageKey": null,
                        "args": (v97/*: any*/),
                        "concreteType": "ItemDisplayInfo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "ctas",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CTADisplay",
                            "plural": false,
                            "selections": [
                              (v98/*: any*/),
                              (v99/*: any*/),
                              (v100/*: any*/),
                              (v101/*: any*/),
                              (v102/*: any*/),
                              (v103/*: any*/),
                              (v104/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "pricing",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PriceInfoDisplay",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "showSold",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "showUnavailable",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "showSale",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "showNet",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "fetchPdp",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "microdata",
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "currency",
                            "variableName": "forcedCurrency"
                          }
                        ],
                        "storageKey": null
                      },
                      (v24/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "pdpMeta",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "pdpMetaItems",
                        "plural": false,
                        "selections": [
                          (v21/*: any*/),
                          (v95/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "ogTitle",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "productPriceAmount",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "productPriceCurrency",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "photos",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ItemPhoto",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "versions",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ItemPhotoVersion",
                            "plural": true,
                            "selections": [
                              (v60/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "type",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ImageVersionType",
                                "plural": false,
                                "selections": (v105/*: any*/)
                              }
                            ]
                          },
                          (v59/*: any*/),
                          (v106/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isMissingTranslatedItemTitle",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isPriceUponRequest",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "seller",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Seller",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "trackedPhone",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Phone",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "phoneNumber",
                                "args": null,
                                "storageKey": null
                              },
                              (v10/*: any*/)
                            ]
                          },
                          {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "fetchUser",
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "favoritesByUser",
                                "storageKey": null,
                                "args": [
                                  {
                                    "kind": "Variable",
                                    "name": "userIds",
                                    "variableName": "userId"
                                  }
                                ],
                                "concreteType": "Favorite",
                                "plural": true,
                                "selections": (v84/*: any*/)
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "metrics",
                        "storageKey": "metrics(metricTypes:[\"LISTING_VIEWS\"],timeRange:\"LAST_6_MONTHS\")",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "metricTypes",
                            "value": [
                              "LISTING_VIEWS"
                            ]
                          },
                          {
                            "kind": "Literal",
                            "name": "timeRange",
                            "value": "LAST_6_MONTHS"
                          }
                        ],
                        "concreteType": "MetricDetailType",
                        "plural": true,
                        "selections": [
                          (v53/*: any*/),
                          (v10/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "attributes",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ItemAttributes",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "period",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "AttributeValue",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "option",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "AttributeOption",
                                "plural": false,
                                "selections": (v107/*: any*/)
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "viewInRoomPhotos",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "viewInRoomPhotos",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "src",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "credits",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "srcSetProps",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "viewInRoomPhotosSrcSet",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "sizes",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "srcSet",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "centerPosition",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "viewInRoomPhotosCenterPosition",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "top",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "left",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "comparatorWidth",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "viewInRoomPhotosComparatorWidth",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "pixel",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "inches",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": "dealerDetailsDisplayInfo",
                        "name": "displayInfo",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ItemDisplayInfo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "ctas",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CTADisplay",
                            "plural": false,
                            "selections": [
                              (v100/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isPublishedPrivate",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isPublishedExclusive",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "classification",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ItemClassification",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "categories",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ItemCategory",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "precedence",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "category",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Category",
                                "plural": false,
                                "selections": [
                                  (v72/*: any*/),
                                  (v19/*: any*/),
                                  (v10/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "skus",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ItemSkuType",
                        "plural": true,
                        "selections": [
                          (v79/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "measurement",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ItemMeasurement",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "convertedMeasurements",
                            "storageKey": "convertedMeasurements(unit:\"IN\")",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "unit",
                                "value": "IN"
                              }
                            ],
                            "concreteType": "ItemConvertedMeasurementsType",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "width",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "height",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": "hoverDimensionsWidth",
                            "name": "display",
                            "storageKey": "display(addLabel:false,fields:[\"width\"])",
                            "args": [
                              (v108/*: any*/),
                              {
                                "kind": "Literal",
                                "name": "fields",
                                "value": [
                                  "width"
                                ]
                              }
                            ],
                            "concreteType": "ItemDisplayMeasurementType",
                            "plural": true,
                            "selections": (v54/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "alias": "hoverDimensionsHeight",
                            "name": "display",
                            "storageKey": "display(addLabel:false,fields:[\"height\"])",
                            "args": [
                              (v108/*: any*/),
                              {
                                "kind": "Literal",
                                "name": "fields",
                                "value": [
                                  "height"
                                ]
                              }
                            ],
                            "concreteType": "ItemDisplayMeasurementType",
                            "plural": true,
                            "selections": (v54/*: any*/)
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "videoVimeo",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "VideoVimeo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "thumbnail",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "includePlayButton",
                                "value": false
                              },
                              {
                                "kind": "Literal",
                                "name": "pad",
                                "value": false
                              },
                              {
                                "kind": "Literal",
                                "name": "size",
                                "value": "w100h75"
                              }
                            ],
                            "storageKey": "thumbnail(includePlayButton:false,pad:false,size:\"w100h75\")"
                          },
                          (v4/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "vimeoId",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "reviews",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ItemReviewDocumentList",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "videoReview",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ItemReview",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v10/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "sortedPhotos",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ItemPhoto",
                        "plural": true,
                        "selections": [
                          (v17/*: any*/),
                          (v59/*: any*/),
                          (v106/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "internalBuyLinks",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "InternalBuyLinkType",
                        "plural": true,
                        "selections": [
                          (v83/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "anchorText",
                            "args": null,
                            "storageKey": null
                          },
                          (v10/*: any*/)
                        ]
                      },
                      {
                        "kind": "Condition",
                        "passingValue": true,
                        "condition": "fetchUser",
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "displayInfo",
                            "storageKey": null,
                            "args": (v97/*: any*/),
                            "concreteType": "ItemDisplayInfo",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "ctas",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "CTADisplay",
                                "plural": false,
                                "selections": [
                                  (v98/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "Condition",
                        "passingValue": false,
                        "condition": "isStoryTellingModuleVariant",
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "creatorContent",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "BrowseContentModule",
                            "plural": false,
                            "selections": [
                              (v72/*: any*/),
                              (v95/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "role",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "sellerId",
                                "args": null,
                                "storageKey": null
                              },
                              (v10/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "seller",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Seller",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "isMakerOrManufacturer",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "sellerPreferences",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "SellerPreferences",
                                "plural": false,
                                "selections": [
                                  (v90/*: any*/)
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "liveStorefrontProfile",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "StorefrontProfile",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "aboutUs",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "photos",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Photo",
                                    "plural": true,
                                    "selections": [
                                      (v29/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "type",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "PhotoType",
                                        "plural": false,
                                        "selections": (v107/*: any*/)
                                      },
                                      (v10/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "isStoryTellingModuleVariant",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "storyTellingModule",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "StoryTellingModule",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "tabs",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "StoryTellingTab",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "tabTitle",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "contentHeader",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "contentCreatorAttribution",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "StoryTellingModuleCreator",
                                "plural": false,
                                "selections": [
                                  (v109/*: any*/),
                                  (v110/*: any*/),
                                  (v63/*: any*/)
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "relatedCreators",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "StoryTellingModuleCreator",
                                "plural": true,
                                "selections": [
                                  (v63/*: any*/),
                                  (v109/*: any*/),
                                  (v110/*: any*/)
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "supplementaryEditorial",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "WordpressArticlesType",
                                "plural": false,
                                "selections": [
                                  (v67/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "articles",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "WordpressArticleType",
                                    "plural": true,
                                    "selections": [
                                      (v21/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "imageUrl",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "WordpressArticleImageType",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "thumb",
                                            "args": null,
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "medium",
                                            "args": null,
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "full",
                                            "args": null,
                                            "storageKey": null
                                          }
                                        ]
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "link",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "source",
                                        "args": null,
                                        "storageKey": null
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "contentBodyText",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "articleLink",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "browseLink",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "LinkData",
                                "plural": false,
                                "selections": (v30/*: any*/)
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "smallImage",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "tabType",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "mainImage",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "mainVideo",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "fetchUser",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isInProcurement",
                        "args": (v92/*: any*/),
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "hasActiveHoldForBuyer",
                        "args": (v89/*: any*/),
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "isMultiSku",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "skus",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ItemSkuType",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "displayInfo",
                            "storageKey": null,
                            "args": (v97/*: any*/),
                            "concreteType": "SkuDisplayInfo",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "ctas",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "CTADisplay",
                                "plural": false,
                                "selections": [
                                  (v99/*: any*/),
                                  (v100/*: any*/),
                                  (v101/*: any*/),
                                  (v102/*: any*/),
                                  (v103/*: any*/),
                                  (v104/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "variableAttributes",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "VariableAttribute",
                        "plural": true,
                        "selections": [
                          (v17/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "variableAttributeData",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "VariableAttributeSortType",
                            "plural": false,
                            "selections": [
                              (v26/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "primaryAttribute",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Attribute",
                                "plural": false,
                                "selections": (v107/*: any*/)
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "swatchSort",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "SwatchSort",
                                "plural": true,
                                "selections": [
                                  (v87/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "swatch",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Swatch",
                                    "plural": false,
                                    "selections": [
                                      (v17/*: any*/),
                                      (v26/*: any*/),
                                      (v95/*: any*/),
                                      (v38/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "material",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "SwatchAttributeByName",
                                        "plural": false,
                                        "selections": (v105/*: any*/)
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "color",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "SwatchAttributeByName",
                                        "plural": false,
                                        "selections": [
                                          (v72/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "parentName",
                                            "args": null,
                                            "storageKey": null
                                          }
                                        ]
                                      },
                                      (v10/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          (v10/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": "buyerSideSkus",
                        "name": "skus",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ItemSkuType",
                        "plural": true,
                        "selections": [
                          (v17/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "firstPhotoWebPath",
                            "args": (v80/*: any*/),
                            "storageKey": "firstPhotoWebPath(size:\"thumb\")"
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "pricing",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ItemPricing",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "hidePrice",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "retailPrice",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "plural": false,
                                "selections": (v111/*: any*/)
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "netPrice",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "plural": false,
                                "selections": (v111/*: any*/)
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "salePrice",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "plural": false,
                                "selections": (v111/*: any*/)
                              }
                            ]
                          },
                          (v74/*: any*/),
                          (v75/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "leadTime",
                            "args": (v76/*: any*/),
                            "storageKey": "leadTime(pageType:\"PDP\")"
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "variableAttributeSelections",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "variableAttributeSelectionsType",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "variableAttribute",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "VariableAttribute",
                                "plural": false,
                                "selections": (v84/*: any*/)
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "swatch",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Swatch",
                                "plural": false,
                                "selections": (v84/*: any*/)
                              },
                              (v10/*: any*/)
                            ]
                          },
                          (v10/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          (v10/*: any*/),
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchUser",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "buyerItemConversation",
                "storageKey": null,
                "args": (v3/*: any*/),
                "concreteType": "Conversation",
                "plural": false,
                "selections": (v84/*: any*/)
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": (v92/*: any*/),
                "concreteType": "User",
                "plural": false,
                "selections": [
                  (v17/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "canShowSellerName",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isVerifiedTrade",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "profile",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Profile",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "email",
                        "args": null,
                        "storageKey": null
                      },
                      (v26/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "measurementUnit",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "firstName",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": "canRequestShippingQuotePermission",
                    "name": "hasPermission",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "B_REQUEST_SHIPPING_QUOTE"
                      }
                    ],
                    "storageKey": "hasPermission(name:\"B_REQUEST_SHIPPING_QUOTE\")"
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "activePromotion",
                    "storageKey": null,
                    "args": [
                      (v2/*: any*/)
                    ],
                    "concreteType": "Promotion",
                    "plural": false,
                    "selections": (v112/*: any*/)
                  },
                  (v10/*: any*/),
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "fetchFollowSearch",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "favorites",
                        "storageKey": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 1
                          },
                          {
                            "kind": "Variable",
                            "name": "pages",
                            "variableName": "followSearchPages"
                          },
                          {
                            "kind": "Literal",
                            "name": "types",
                            "value": [
                              "SEARCH",
                              "USER_PREFERENCE"
                            ]
                          }
                        ],
                        "concreteType": "favoritesConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "favoritesEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Favorite",
                                "plural": false,
                                "selections": (v84/*: any*/)
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "isTrade",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "expiringPromotion",
                        "storageKey": "expiringPromotion(daysToExpiration:7,promoCodes:[\"TRADEWELCOME\",\"TRADE1STWELCOME\"])",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "daysToExpiration",
                            "value": 7
                          },
                          {
                            "kind": "Literal",
                            "name": "promoCodes",
                            "value": [
                              "TRADEWELCOME",
                              "TRADE1STWELCOME"
                            ]
                          }
                        ],
                        "concreteType": "Promotion",
                        "plural": false,
                        "selections": [
                          (v113/*: any*/),
                          (v12/*: any*/),
                          (v10/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "tradeFirmRewards",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TradeFirmRewards",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "currentPromoSegment",
                            "storageKey": null,
                            "args": (v92/*: any*/),
                            "concreteType": "currentPromoSegmentType",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "promotion",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Promotion",
                                "plural": false,
                                "selections": [
                                  (v12/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "buyerExpirationDate",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  (v10/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "expiringPromoSegment",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "expiringPromoSegmentType",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "expiringSegmentCode",
                                "args": null,
                                "storageKey": null
                              },
                              (v113/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "tradeFirm",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TradeFirmType",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "rewards",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "TradeFirmRewards",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "currentPromoSegment",
                                "storageKey": null,
                                "args": (v92/*: any*/),
                                "concreteType": "currentPromoSegmentType",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "segmentCode",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "currentProgram",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ParentProgram",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "programInfo",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "LoyaltyProgram",
                                    "plural": false,
                                    "selections": (v112/*: any*/)
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "childPrograms",
                                    "storageKey": "childPrograms(filter:\"ENHANCED_BUYER_PROTECTION\")",
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "filter",
                                        "value": "ENHANCED_BUYER_PROTECTION"
                                      }
                                    ],
                                    "concreteType": "LoyaltyProgram",
                                    "plural": true,
                                    "selections": (v112/*: any*/)
                                  }
                                ]
                              }
                            ]
                          },
                          (v10/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "tradeFirmDesignManagerProfile",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TradeFirmDesignManagerProfileType",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "hasAccount",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "accountType",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "socialNetworks",
                        "storageKey": "socialNetworks(socialNetworkNames:\"DESIGN_MANAGER\")",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "socialNetworkNames",
                            "value": "DESIGN_MANAGER"
                          }
                        ],
                        "concreteType": null,
                        "plural": true,
                        "selections": [
                          (v63/*: any*/),
                          (v10/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "type": "DesignManagerSocialNetworkType",
                            "selections": [
                              (v4/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "fetchUserRecentHistoryItem",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "recentHistoryItems",
                        "storageKey": null,
                        "args": (v115/*: any*/),
                        "concreteType": "RecentHistoryItemsConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "RecentHistoryItemsEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Item",
                                "plural": false,
                                "selections": [
                                  (v88/*: any*/),
                                  (v79/*: any*/),
                                  (v94/*: any*/),
                                  (v21/*: any*/),
                                  (v19/*: any*/),
                                  (v20/*: any*/),
                                  (v17/*: any*/),
                                  (v18/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "seller",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Seller",
                                    "plural": false,
                                    "selections": (v84/*: any*/)
                                  },
                                  (v10/*: any*/),
                                  (v63/*: any*/)
                                ]
                              },
                              (v64/*: any*/)
                            ]
                          },
                          (v70/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedHandle",
                        "alias": null,
                        "name": "recentHistoryItems",
                        "args": (v115/*: any*/),
                        "handle": "connection",
                        "key": "getRecentHistory_recentHistoryItems",
                        "filters": [
                          "excludeItemPks"
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isClient",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "transactionWarnings",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "country",
                    "variableName": "userCountryCode"
                  },
                  (v2/*: any*/)
                ],
                "concreteType": "TransactionWarningQueryType",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hasRestrictedMaterials",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isCheckoutBlocked",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "relevantShipping",
                "storageKey": null,
                "args": (v3/*: any*/),
                "concreteType": "RelevantShippingInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "shipmentQuotes",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ShipmentQuote",
                    "plural": true,
                    "selections": [
                      (v17/*: any*/),
                      (v33/*: any*/),
                      (v14/*: any*/),
                      (v34/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "serviceMethod",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ShipmentServiceMethod",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "serviceType",
                            "args": null,
                            "storageKey": null
                          },
                          (v11/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "region",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Region",
                            "plural": false,
                            "selections": (v112/*: any*/)
                          },
                          (v10/*: any*/)
                        ]
                      },
                      (v10/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "transactions",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "buyerId",
                    "variableName": "userIds"
                  },
                  {
                    "kind": "Variable",
                    "name": "itemId",
                    "variableName": "itemIds"
                  }
                ],
                "concreteType": "TransactionConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "isMultiSku",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TransactionEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Transaction",
                            "plural": false,
                            "selections": [
                              (v73/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "isPrivateOffer",
                                "args": null,
                                "storageKey": null
                              },
                              (v116/*: any*/),
                              (v10/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "Condition",
                "passingValue": true,
                "condition": "isInteractivePdpChat",
                "selections": [
                  (v117/*: any*/),
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "fetchUser",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "buyerItemConversation",
                        "storageKey": null,
                        "args": (v3/*: any*/),
                        "concreteType": "Conversation",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "hasUnreadMessageForMember",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "originalBuyer",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ConversationMember",
                            "plural": false,
                            "selections": (v84/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "originalSeller",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ConversationMember",
                            "plural": false,
                            "selections": (v84/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "transaction",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Transaction",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "orderFeedback",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "OrderFeedback",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "token",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  (v10/*: any*/)
                                ]
                              },
                              (v10/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "messages",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Message",
                            "plural": true,
                            "selections": [
                              (v17/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "textBody",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "createdDate",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "createdDateFormatted",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "fromUserId",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "shipmentTrackingNumber",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "action",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "MessageAction",
                                "plural": false,
                                "selections": (v107/*: any*/)
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "anchors",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Anchor",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "sourceType",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "attachments",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "MessageAttachment",
                                "plural": true,
                                "selections": [
                                  (v63/*: any*/),
                                  (v10/*: any*/)
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "actionRequestedNetPrice",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "actionMadePrivateOffer",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "actionMadeNetPriceOffer",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "actionMadeOffer",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "actionAutomatedPrivateOffer",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "actionShippingQuoteSent",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "actionSpecialShippingRequests",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "actionRequestedHold",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "actionHoldPlaced",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "actionHoldReleased",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "actionShippingQuoteRequested",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "actionCallInitiated",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "actionCustomizationOffer",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "actionCustomization",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "actionBundledOffer",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "actionPrivateOfferShippingQuoteSent",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "actionPrivateOfferHoldSent",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "actionHoldShippingQuoteSent",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "actionInternalAdminJoined",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "actionMarkedShipped",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "actionReturnRequested",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "actionReturnApproved",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "actionReturnCompleted",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "actionReturnDeclined",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "actionDealerCounterOffer",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "actionBuyerCounterOffer",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "offer",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Offer",
                                "plural": false,
                                "selections": [
                                  (v17/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "isApoFromCart",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "expirationDate",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "amountPerItem",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "FinancialAmount",
                                    "plural": false,
                                    "selections": [
                                      (v41/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "isExpired",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "isSubmitted",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "isRevisedByDealer",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "isCountered",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  (v10/*: any*/)
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "transaction",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Transaction",
                                "plural": false,
                                "selections": [
                                  (v116/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "mostRecentOffer",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Offer",
                                    "plural": false,
                                    "selections": (v84/*: any*/)
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "summary",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "TransactionSummaryObject",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "offerDiscountPercentage",
                                        "args": null,
                                        "storageKey": null
                                      }
                                    ]
                                  },
                                  (v10/*: any*/)
                                ]
                              },
                              (v10/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "from",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ConversationMember",
                                "plural": false,
                                "selections": (v84/*: any*/)
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "Condition",
                "passingValue": false,
                "condition": "isInteractivePdpChat",
                "selections": [
                  (v117/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchRegionalInfo",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "regionalInfo",
                "storageKey": null,
                "args": [
                  (v68/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "zipCode",
                    "variableName": "userZipCode"
                  }
                ],
                "concreteType": "RegionalInfo",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "regionsByZipCode",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "RegionsByZipCode",
                    "plural": true,
                    "selections": [
                      (v26/*: any*/)
                    ]
                  },
                  (v10/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchPdp",
            "selections": [
              {
                "kind": "ScalarField",
                "alias": "isRequestMoreImagesEnabled",
                "name": "isEnabledByLocale",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "REQUEST_MORE_IMAGES"
                  }
                ],
                "storageKey": "isEnabledByLocale(featureName:\"REQUEST_MORE_IMAGES\")"
              },
              {
                "kind": "ScalarField",
                "alias": "videoUploadToolsFeatureFlag",
                "name": "featureFlag",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "feature",
                    "value": "videoUploadTools"
                  }
                ],
                "storageKey": "featureFlag(feature:\"videoUploadTools\")"
              },
              {
                "kind": "ScalarField",
                "alias": "isContactSupportEnabled",
                "name": "isEnabledByLocale",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "CONTACT_1STDIBS"
                  }
                ],
                "storageKey": "isEnabledByLocale(featureName:\"CONTACT_1STDIBS\")"
              },
              {
                "kind": "ScalarField",
                "alias": "disablePdpExitModal",
                "name": "isEnabled",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "key",
                    "value": "disablePdpExitModal"
                  }
                ],
                "storageKey": "isEnabled(key:\"disablePdpExitModal\")"
              },
              {
                "kind": "ScalarField",
                "alias": "isAboutTheMakerEnabled",
                "name": "isEnabledByLocale",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "ABOUT_THE_MAKER"
                  }
                ],
                "storageKey": "isEnabledByLocale(featureName:\"ABOUT_THE_MAKER\")"
              },
              {
                "kind": "ScalarField",
                "alias": "isPdpUrlTranslationEnabled",
                "name": "isEnabled",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "key",
                    "value": "translatedPdpUrls"
                  }
                ],
                "storageKey": "isEnabled(key:\"translatedPdpUrls\")"
              },
              {
                "kind": "LinkedField",
                "alias": "similarLandingItems",
                "name": "moreLikeThisItem",
                "storageKey": null,
                "args": [
                  (v114/*: any*/),
                  (v2/*: any*/)
                ],
                "concreteType": "moreLikeThisItemConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "moreLikeThisItemEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Item",
                        "plural": false,
                        "selections": [
                          (v17/*: any*/),
                          (v18/*: any*/),
                          (v20/*: any*/),
                          (v19/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v94/*: any*/),
                          (v28/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "creators",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ItemCreator",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "creator",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Creator",
                                "plural": false,
                                "selections": (v107/*: any*/)
                              },
                              (v10/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "photos",
                            "storageKey": "photos(limit:1)",
                            "args": (v57/*: any*/),
                            "concreteType": "ItemPhoto",
                            "plural": true,
                            "selections": [
                              (v59/*: any*/),
                              (v61/*: any*/),
                              (v10/*: any*/),
                              (v58/*: any*/)
                            ]
                          },
                          (v10/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "Condition",
                "passingValue": true,
                "condition": "fetchPdp",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": "isPdpStfEnabled",
                    "name": "featureFlag",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "enablePdpStf"
                      }
                    ],
                    "storageKey": "featureFlag(feature:\"enablePdpStf\")"
                  },
                  (v118/*: any*/),
                  (v119/*: any*/)
                ]
              },
              {
                "kind": "Condition",
                "passingValue": true,
                "condition": "isTrade",
                "selections": [
                  (v118/*: any*/),
                  (v119/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": "isInvoiceEnabled",
                    "name": "featureFlag",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "pdpTradeInvoiceBubble"
                      }
                    ],
                    "storageKey": "featureFlag(feature:\"pdpTradeInvoiceBubble\")"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "PdpRespLayoutRefetchQuery",
    "id": "app-buyer-finding/293.0.0-2020-12-09T21:42:09.926Z/PdpRespLayoutRefetchQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = 'b2cec78f8ae3cb23093ae3276379ba4c';
export default node;
